import { Link } from '@tiptap/extension-link'

export const InternalLinking = Link.extend({
  name: 'link',

  addAttributes() {
    return {
      ...this.parent?.(),

      docId: {
        default: null,
        parseHTML: element => element.getAttribute('data-doc-id'),
        renderHTML: attrs =>
          attrs.docId
            ? { 'data-doc-id': attrs.docId }
            : {},
      },
      hoverContent: {
        default: null,
        parseHTML: element => element.getAttribute('hover-content'),
        renderHTML: attrs =>
          attrs.hoverContent
            ? { 'hover-content': attrs.hoverContent }
            : {'hover-content': ''},
      },
    }
  },
})
